import React from 'react';
import PropTypes from 'prop-types';
import withModifiers from '../../../_utils/withModifiers';

var Image = function Image(_ref) {
  var modifiers = _ref.modifiers,
      src = _ref.src,
      srcset = _ref.srcset,
      sizes = _ref.sizes,
      alt = _ref.alt,
      title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    className: withModifiers('image')(modifiers),
    src: src,
    srcSet: srcset,
    sizes: sizes,
    alt: alt,
    title: title
  }), children);
};

export var imageTypeProps = PropTypes.shape({
  modifiers: PropTypes.arrayOf(PropTypes.string),
  src: PropTypes.string,
  srcset: PropTypes.string,
  sizes: PropTypes.string,
  alt: PropTypes.string,
  title: PropTypes.string
});
export default Image;